module.exports = __webpack_public_path__ + "img/Project-3.cef8c04.png";